<template>
    <div>
      <h2>Google Analytics Test</h2>
      <label for="event_name">Event Name: </label>
      <input type="text" id="event_name" placeholder="Event name" v-model="event_name">
      <br>
      <label for="parameter">Parameter: </label>
      <input type="text" placeholder="Parameter name" v-model="event_parameter.param_name" style="margin-right: 3px;">
      <input type="text" placeholder="Parameter value" v-model="event_parameter.param_value">
      <a :class="{'c-button-blue':true,'-small':true,'-disabled':!event_name.trim()}" @click="sendGARequest">
        <span class="label">Submit</span>
      </a>
      <h2>Sentry Test</h2>
      <a :class="{'c-button-blue': true,  '-small': true, '-disabled': disabledBackendBtn}" @click="sendSentryBackendRequest">
        <span class="label">Backend</span>
      </a>
      <a :class="{'c-button-blue': true,  '-small': true, '-disabled': disabledFrontendBtn}" @click="sendSentryFrontendRequest">
        <span class="label">Frontend</span>
      </a>
    </div>
</template>

<script setup lang="ts">
  import { ref } from "vue";
  import * as Sentry from "@sentry/browser";
  import axios from "axios";
  import {event} from "vue-gtag";
  
  const event_name = ref('')
  const event_parameter  = ref({param_name:'', param_value: ''})
  document.title = "External tool test page"
  const disabledBackendBtn = ref(false)
  const disabledFrontendBtn = ref(false)

  function sendGARequest(){
    if(event_name.value.trim() !== ''){
      if(event_parameter.value.param_name.trim() !== ''){
        event(`${event_name.value.trim()}`, {
          [event_parameter.value.param_name.trim()]: event_parameter.value.param_value.trim()
        })
      } else {
        event(`${event_name.value.trim()}`)
      }
    }
  }
  function sendSentryBackendRequest(){
    disabledBackendBtn.value = true
    axios.get("/student/api/testing/error").then(() => {
      setTimeout(() => disabledBackendBtn.value = false, 1000)
    })
  }
  function sendSentryFrontendRequest() {
    disabledFrontendBtn.value = true
    Sentry.captureMessage("Sentry error test from frontend", 'error')
    setTimeout(() => disabledFrontendBtn.value = false, 1000)
  }
</script>
